import { CircleCheck } from 'lucide-react'
import { useTranslation } from '@/i18n'
import { useAppStore } from '@/store'
import { IntuiButton } from '@/components/intueri/IntuiButton'

/** "Thanks for your feedback!" terminal view of the rating flow. */
const ThanksView = () => {
  const { t } = useTranslation('help_agent')
  const finishHelpFeedback = useAppStore((s) => s.finishHelpFeedback)

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
      <CircleCheck className="size-10 text-green-600" />
      <h3 className="text-base font-semibold text-gray-900 dark:text-dark-text">
        {t('feedback.thanks_title')}
      </h3>
      <p className="text-sm text-muted-foreground">{t('feedback.thanks_body')}</p>
      <IntuiButton variant="outline" onClick={finishHelpFeedback} className="mt-2">
        {t('feedback.done')}
      </IntuiButton>
    </div>
  )
}

export default ThanksView
